import clientUUID from "@/client";

export const site_domain = process.env.VUE_APP_URL;
export const domain = process.env.VUE_APP_API_URL;
export const dateFormat = 'DD/MM/YYYY';

export const makeQuery = (fields) => Object
  .entries(fields)
  .map(([field, {serialize, value, rules, query_key}]) => ({
    field: query_key || field,
    value: serialize !== undefined ? serialize(value) : value
  }))
  .filter(({value}) => value !== undefined)
  .reduce((carry, {field, value}) => Object.defineProperty(carry, field, {value, enumerable: true}), {});

export const queryParams = params => Object.entries(params)
  .map(param => param.map(encodeURIComponent))
  .map(param => `${param[0]}=${param[1]}`)
  .join('&');

export const isValidDate = date => date instanceof Date
  && !isNaN(date.getTime())
  && date.getFullYear() > 2000; // cacat

export const formatDate = date => date.toLocaleDateString('ro-RO');

export const ucfirst = s => s[0].toLocaleUpperCase() + s.slice(1);

export const ping = () => fetch(`${domain}/ro/ping`, {
  method: 'get',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Client-UUID': clientUUID
  }
});
